import type { LinkedActivityParticipation } from "@/pages/activities/activity-types/types";

export type PdrHistoryParticipationLinkage = {
  activityParticipation?: Pick<LinkedActivityParticipation, "id" | "isTypeLevelParticipation"> | null;
};

function getPdrParticipationKind(record: PdrHistoryParticipationLinkage) {
  if (!record.activityParticipation) {
    return "ccms-legacy";
  }

  if (record.activityParticipation.isTypeLevelParticipation) {
    return "type-level";
  }

  return "activity-level";
}

export function isCcmsLegacyPdrCredit(record: PdrHistoryParticipationLinkage): boolean {
  return getPdrParticipationKind(record) === "ccms-legacy";
}

export function isTypeLevelPdrParticipation(record: PdrHistoryParticipationLinkage): boolean {
  return getPdrParticipationKind(record) === "type-level";
}
